<div (click)="addToCartSwatch()" class="fb-swatch-button">
	<div class="swatch-wrapper">
		<div class="custom-border" [ngStyle]="{'background': 'url(' + product.heroImage + ')'}">
		</div>
	</div>
	<div>
		<p class=" font-medium">Order a Swatch</p>
		<button class="swatch-add"><span *ngIf="swatchPrice>0" class="font-bold"><span class="text-xs mr-0.5 grey-text">{{selectedCurrency | uppercase}}</span> {{swatchPrice | currencyConverter | number: '1.0-2'}}</span></button>
	</div>
</div>
